// extracted by mini-css-extract-plugin
export default {"score":"Score_score__rMBg3","plays":"Score_plays__Kq6i8","pink":"Score_pink__uDO0C","blue":"Score_blue__1v2AW","orange":"Score_orange__vivkH","green":"Score_green__ON6SE"};